<template>
  <div class="w-wrap" :class="[$route.name + '-wrap']">
    <!-- <slot name="header">
      <c-header></c-header>
    </slot> -->
    <div class="main-content">
      <!-- <transition name="bounce"> -->
      <router-view></router-view>
      <!-- </transition> -->
    </div>
    <slot name="footer">
      <c-footer></c-footer>
    </slot>
  </div>
</template>

<script>
import CHeader from "components/c-header/index.vue";
import CFooter from "components/c-footer/index.vue";

export default {
  name: "app",
  components: {
    CHeader,
    CFooter,
  },
};
</script>

<style rel="stylesheet/less" lang="less">
@import "global\css\mixin\mixin.less";
.w-wrap {
  height: 100%;
  // overflow: hidden;
  &.word-extract-wrap {
    .c-footer {
      display: none;
    }
  }

  &.aboutUs-wrap,
  &.announcement-wrap,
  &.joinUs-wrap,
  &.joinUsDetail-wrap,
  &.contactUs-wrap,
  &.joinUsMain-wrap,
  &.announcementList-wrap,
  &.sceneService-wrap,
  &.financing-wrap,
  &.eight-festival-wrap,
  &.order-installment-wrap,
  &.service-provider-wrap {
    height: auto;
    .main-content {
      overflow: visible;
    }
  }
  &.financing-wrap,
  &.eight-festival-wrap,
  &.order-installment-wrap,
  &.service-provider-wrap {
    .c-footer {
      display: none;
    }
  }
}
.main-content {
  overflow: hidden;
  background: #eee;
  height: 100%;
  box-sizing: border-box;
  .root {
    background: #fff;
    color: #555;
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  display: none;
}
@keyframes bounce-in {
  0% {
    /*transform: scale(0);*/
    transform: translateX(100px);
    opacity: 0;
  }
  100% {
    /*transform: scale(1);*/
    transform: translateX(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// app.vue?73eee7aa